/**
 * @license
 * Copyright (C) 2022 Anna Plodari
 * Software proprietario - Tutti i diritti riservati.
 * Registrato SIAE - Sezione OLAF.
 *
 * È vietato qualsiasi utilizzo non autorizzato, copia, modifica, estrazione,
 * riuso, rielaborazione, distribuzione, reverse engineering o decompilazione
 * del software, delle API, delle logiche applicative e dei dati del database.
 *
 * L'accesso al codice non costituisce concessione di licenza.
 */
import React from 'react';
import CompanyNavBar from '../../components/CompanyNavBar';
import PrimaryButton from '../../components/PrimaryButton';
import FullScreenSpinner from '../../components/FullScreenSpinner';
import { useAuth } from '../../commons/Auth';
import useMe from '../../lib/hooks/useMe';

const PaymentSuccess: React.FC = function PaymentSuccess() {
  const { token }: any = useAuth();
  const { isFetching } = useMe(token, undefined, {
    enabled: Boolean(token),
    refetchOnMount: 'always',
  });

  if (isFetching) {
    return <FullScreenSpinner />;
  }

  return (
    <div>
      <div className="absolute h-screen bg-upgrade w-full bg-cover bg-no-repeat top-0 right-0 -z[-1px] hidden lg:block" />
      <CompanyNavBar noMenu />
      <div className="flex flex-col justify-center items-center mt-32 relative z-10">
        <h1 className="font-primarybold text-2xl text-primary mb-2">Pagamento andato a buon fine!</h1>
        <p className="font-primarybold text-textgrey mb-8">I crediti sono stati aggiunti al tuo profilo</p>
        <img src="./assets/success-img.svg" alt="success img" className="mb-16" />
        <PrimaryButton linkButton linkText="Torna alla home" to="/company-home" />
      </div>
    </div>
  );
};

export default PaymentSuccess;
